// Module
var code = "<input data-bind=\" attr: {id: _id}, click: ShowSelector, style: {backgroundColor: _selectedColorValue}, value: _selectedColorName\" type=\"text\" autocomplete=\"off\" class=\"minicolors-input text-editor form-control\"/>";
// Exports
export default code;